<template>
    <nav ref="root" :class="rootClass">
        <slot></slot>
    </nav>
</template>

<script>
import {onMounted, ref} from "vue";
import {transitionClassesOpen, transitionClassesClose} from "@/utils";

export default {
    name: "footer-nav-toggle",
    props: {
        class: {
            type: String,
            default: ""
        }
    },
    setup(props) {
        const root = ref(null);
        const activeItems = ref([]);
        const rootClass = ref(props.class);

        const open = (i) => {
            activeItems.value.push(i)
            const child = i.querySelector('.page-footer__sub')
            i.querySelector('.mdc-button__icon').innerText = "expand_less"
            if (child) {
                transitionClassesOpen({
                    el: i,
                    dropDown: child
                })
            }
        }

        const close = (i) => {
            activeItems.value.splice(activeItems.value.indexOf(i),1)
            const child = i.querySelector('.page-footer__sub')
            i.querySelector('.mdc-button__icon').innerText = "expand_more"
            if (child) {
                transitionClassesClose({
                    el: i,
                    dropDown: child
                })
            }
        }

        onMounted(() => {
            const items = root.value.querySelectorAll(".has-child")
            items.forEach((i) => {
                const toggle = i.querySelector('button')
                toggle.addEventListener("click",(e)=>{
                    e.stopPropagation()
                    if (activeItems.value.indexOf(i) === -1) {
                        activeItems.value.forEach((elem) => {
                            close(elem)
                        })
                        open(i)
                    } else {
                        close(i)
                    }
                })

            })
        })

        return {
            root,
            rootClass
        }
    }
}
</script>
